import { Area, AreaChart, ResponsiveContainer } from 'recharts';
import { tokenColor } from '@/utils/theme';

interface SparklineProps {
  data: number[];
  positive: boolean;
  height?: number;
}

export default function Sparkline({ data, positive, height = 48 }: SparklineProps) {
  const color = positive ? tokenColor('accent-500') : tokenColor('secondary-500');
  const series = data.map((value, index) => ({ index, value }));

  return (
    <div className="w-full" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={series} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id={positive ? 'spark-up' : 'spark-down'} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.35} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={1.6}
            fill={`url(#${positive ? 'spark-up' : 'spark-down'})`}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}